/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "./type";
/**
 * Describes the mode used to abbreviate large numbers
 */
export var DataAbbreviationMode = /*@__PURE__*/ (function (DataAbbreviationMode) {
    /**
     * Specifies abbreviation that is automatically resolves to shared abbreviation between multiple numbers, 2.5K for 2,500 and 2500K for 2,500,000
     */
    DataAbbreviationMode[DataAbbreviationMode["Auto"] = 0] = "Auto";
    /**
     * Specifies independent abbreviation for multiple numbers, 2.5K for 2,500 and 2.5M for 2,500,000
     */
    DataAbbreviationMode[DataAbbreviationMode["Independent"] = 1] = "Independent";
    /**
     * Specifies shared abbreviation between multiple numbers, 2.5K for 2,500 and 2500K for 2,500,000
     */
    DataAbbreviationMode[DataAbbreviationMode["Shared"] = 2] = "Shared";
    /**
     * Specifies number abbreviation to thousands, 2.5K for 2,500
     */
    DataAbbreviationMode[DataAbbreviationMode["Kilo"] = 3] = "Kilo";
    /**
     * Specifies number abbreviation to millions, 2.5M for 2,500,000
     */
    DataAbbreviationMode[DataAbbreviationMode["Million"] = 4] = "Million";
    /**
     * Specifies number abbreviation to billion, 2.5B for 2,500,000,000
     */
    DataAbbreviationMode[DataAbbreviationMode["Billion"] = 5] = "Billion";
    /**
     * Specifies number abbreviation to trillion, 2.5T for 2,500,000,000,000
     */
    DataAbbreviationMode[DataAbbreviationMode["Trillion"] = 6] = "Trillion";
    /**
     * Specifies number abbreviation to quadrillion, 2.5Q for 2,500,000,000,000,000
     */
    DataAbbreviationMode[DataAbbreviationMode["Quadrillion"] = 7] = "Quadrillion";
    /**
     * Specifies default abbreviation
     */
    DataAbbreviationMode[DataAbbreviationMode["Unset"] = 8] = "Unset";
    /**
     * Specifies no abbreviation of numbers
     */
    DataAbbreviationMode[DataAbbreviationMode["None"] = 9] = "None";
    return DataAbbreviationMode;
})({});
/**
 * @hidden
 */
export var DataAbbreviationMode_$type = /*@__PURE__*/ markEnum('DataAbbreviationMode', 'Auto,0|Independent,1|Shared,2|Kilo,3|Million,4|Billion,5|Trillion,6|Quadrillion,7|Unset,8|None,9');
